// extracted by mini-css-extract-plugin
module.exports = {"blurred_thumbnail":"Thumbnail_blurred_thumbnail__iuW_q","container":"Thumbnail_container__1wf9U"};